"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEffectWithWeb3 = void 0;
var react_1 = require("react");
var _shared_1 = require("../../shared");
/**
 * This effect triggers only when the Web3 instance exists. Does nothing while Web3 is being initialized.
 */
function useEffectWithWeb3(cb, deps, web3) {
    var staticWeb3 = (0, _shared_1.useWeb3Provider)().staticWeb3;
    var activeWeb3 = web3 || staticWeb3;
    (0, react_1.useEffect)(function () {
        if (!activeWeb3)
            return;
        return cb(activeWeb3);
    }, __spreadArray([activeWeb3], (deps || []), true));
}
exports.useEffectWithWeb3 = useEffectWithWeb3;
